import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["value", "format", "textColor", "formatContent"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import PropTypes from 'prop-types';
import React from 'react';
import { computeHeightInPixels } from '../heightProps';
import Label from './label';
import entityComposition from '../../common/classes/entityComposition';
import { valueSelector } from '../selectors';
import { getFormatContent } from '../selectors/simpleSelectors';
const LabelView = _ref => {
  let value = _ref.value,
    format = _ref.format,
    _ref$textColor = _ref.textColor,
    textColor = _ref$textColor === void 0 ? null : _ref$textColor,
    _ref$formatContent = _ref.formatContent,
    formatContent = _ref$formatContent === void 0 ? null : _ref$formatContent,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  const labelValue = formatContent || value;
  const height = computeHeightInPixels(_objectSpread({
    value,
    format,
    textColor,
    formatContent
  }, otherProps));
  const className = format.align ? "text-".concat(format.align) : '';
  return /*#__PURE__*/React.createElement(Label, {
    value: labelValue,
    className: "\"t-lv ".concat(className),
    style: {
      minHeight: height
    },
    color: textColor
  });
};
LabelView.propTypes = {
  /* eslint-disable react/forbid-prop-types */
  value: PropTypes.string.isRequired,
  formatContent: PropTypes.string,
  format: PropTypes.object.isRequired,
  textColor: PropTypes.shape({
    red: PropTypes.number,
    green: PropTypes.number,
    blue: PropTypes.number
  })
  /* eslint-enable react/forbid-prop-types */
};
export { LabelView as UncomposedLabelView };
export default entityComposition(LabelView, [], {
  value: valueSelector,
  formatContent: getFormatContent
});